import React from 'react';

import PropTypes from 'prop-types';

import {
	Badge,
	Input,
	InputGroup,
	InputGroupAddon,
	Option,
	Select,
	Tooltip,
} from '@sm/wds-react';

import { IconCaretLeft, IconCaretRight, IconSearch } from '@sm/wds-icons';

import {
	GroupedMenu,
	GroupedMenuHeader,
	GroupedMenuBody,
	GroupedMenuBodyLeft,
	GroupedMenuBodyRight,
	GroupedMenuItem,
} from '@sm/ads';


export default class Piper extends React.Component {
	// Check if pane has an element that has children
	static paneHasParent(data) {
		const itemsWithParents = data.map(item => Object.keys(item).includes('data'));

		return itemsWithParents.length > 0;
	}

	constructor(props) {
		super(props);

		this.state = {
			data: props.data,
			leftPane: props.data,
			parent: props.data[0],
			rightPane: [],
			parent: null,
			selected: [],
			previouslySelected: null,
			previousGroup: [],
			depth: 0,
			searchTerm: '',
		};

		// ES6 React.Component doesn't auto bind methods to itself
		this.handleSearch = this.handleSearch.bind(this);
		this.updateQueue = this.updateQueue.bind(this);
		this.handleChildClick = this.handleChildClick.bind(this);
		this.handleParentClick = this.handleParentClick.bind(this);
		this.handlePreviousClick = this.handlePreviousClick.bind(this);
		this.handleBadgeRemove = this.handleBadgeRemove.bind(this);
	}

	handleBadgeRemove(e, index) {
		const { selected } = this.state;

		const newSelection = selected;
		newSelection.splice(index, 1);

		this.updateQueue(newSelection);
	}

	updateQueue(newSelection) {
		const { updateQueue } = this.props;

		this.setState({ selected: newSelection });
		updateQueue(newSelection);
	}

	handleChildClick(e, item) {
		const { parent, selected } = this.state;
		const newSelection = selected;

		newSelection.push({
			id: item.id,
			label: item.label,
			value: item.value,
			group: parent.label,
			isMulti: item.is_multi,
		});

		this.updateQueue(newSelection);
	}

	handlePreviousClick() {
		const {
			depth,
			leftPane,
			previousGroup,
			previouslySelected,
		} = this.state;

		this.setState({
			rightPane: leftPane,
			leftPane: previousGroup,
			depth: depth - 1,
			parent: previouslySelected,
		});
	}

	handleParentClick(e, item, panel) {
		const {
			depth,
			leftPane,
			parent,
			rightPane,
		} = this.state;

		if (parent && item.id === parent.id) {
			return;
		}

		if (panel === 'right' && Piper.paneHasParent(rightPane)) {
			this.setState({
				previousGroup: leftPane,
				leftPane: rightPane,
				depth: depth + 1,
			});
		}

		this.setState({
			previouslySelected: parent,
			parent: item,
			rightPane: item.data,
		});
	}

	handleSearch(e) {
		const searchTerm = e.target.value;

		const {
			data,
		} = this.state;

		const resultTree = this.search(searchTerm, data);

		let rightPane;

		if (!resultTree.length) {
			rightPane = [];
		} else {
			rightPane = resultTree[0].data || [];
		}

		this.setState({
			leftPane: resultTree,
			parent: resultTree[0],
			rightPane,
			searchTerm,
		});
	}

	search(searchTerm, treeNode) {
		const result = [];

		function childMatchesSearch(node, search) {
			let result = {
				label: node.label,
				id: node.id,
				value: node.value,
				isMulti: node.isMulti,
			};

			if (node.hasOwnProperty('data')) {
				result = {
					label: node.label,
					id: node.id,
					data: node.data,
					extra_data: node.extra_data,
				}
			}

			let hasMatch = false;

			if (node.label.toLowerCase().includes(search)) {
				hasMatch = true;
			} else if (node.hasOwnProperty('data')) {
				const matchedChildren = [];

				for (const subNode of node.data) {
					let childMatch = childMatchesSearch(subNode, search);

					if (childMatch) {
						matchedChildren.push(childMatch);
					}
				}

				result.data = matchedChildren;
				hasMatch = matchedChildren.length > 0;
			}

			if (!hasMatch) {
				return null;
			}

			return result;
		}

		for (let item of treeNode) {
			let searchResult = childMatchesSearch(item, searchTerm.toLowerCase());
			if (searchResult !== null) {
				result.push(searchResult);
			}
		}

		return result;
	}

	tooltipOnMouseExit(e) {
		$(e.target).tooltip('hide')
	}

	paneRenderer(data, panel) {
		const {
			depth,
			parent,
			previouslySelected,
		} = this.state;

		const menuItems = [];
		if (depth > 0 && panel === 'left') {
			menuItems.push(
				<GroupedMenuItem
					onClick={e => this.handlePreviousClick(e, previouslySelected)}
					className="wds-flex previous"
				>
					<div>
						<IconCaretLeft />
					</div>
					<span>{previouslySelected.label}</span>
				</GroupedMenuItem>,
			);
		}

		menuItems.push(data.map((item) => {
			const hasChildren = 'data' in item;

			if (hasChildren) {
				const isSelected = (parent && item.id === parent.id);

				const hasExtraData = Object.entries(item.extra_data).length > 0;

				let tooltipText = '';
				if (hasExtraData) {
					tooltipText = `Stage: ${item.extra_data.round_name}<br>Program: ${item.extra_data.program_name}`;
				}

				return (
					<GroupedMenuItem
						key={item.id}
						onClick={e => this.handleParentClick(e, item, panel)}
						onMouseLeave={e => this.tooltipOnMouseExit(e)}
						className={`wds-flex wds-flex--between parent ${isSelected ? 'selected' : ''}`}
						data-toggle={hasExtraData ? 'tooltip' : undefined}
						data-placement={hasExtraData ? 'top' : undefined}
						data-html={hasExtraData ? 'true' : undefined}
						title={hasExtraData ? tooltipText : undefined}
						data-delay={hasExtraData ? '{"show":"500"}' : undefined}
					>
						<span>{item.label}</span>
						<div className={`${isSelected ? '' : 'ads-invisible'}`}>
							<IconCaretRight />
						</div>
					</GroupedMenuItem>
				);
			}

			return (
				<GroupedMenuItem
					key={item.id}
					onClick={e => this.handleChildClick(e, item)}
				>
					{item.label}
				</GroupedMenuItem>
			);
		}));

		return menuItems;
	}

	render() {
		const {
			leftPane,
			rightPane,
			searchTerm,
			selected,
		} = this.state;

		return (
			<React.Fragment>
				<GroupedMenu>
					<GroupedMenuHeader>
						<InputGroup stretched>
							<Input
								onKeyPress={(e) => {
									if (e.charCode === 13) {
										e.preventDefault();
									}
								}}
								value={searchTerm}
								onChange={this.handleSearch}
								placeholder={gettext('Search...')}
							/>
							<InputGroupAddon><IconSearch /></InputGroupAddon>
						</InputGroup>
					</GroupedMenuHeader>
					<GroupedMenuBody className="wds-flex">
						<GroupedMenuBodyLeft className="wds-flex__item--grow">
							{this.paneRenderer(leftPane, 'left')}
						</GroupedMenuBodyLeft>
						<GroupedMenuBodyRight className="wds-flex__item--grow">
							{this.paneRenderer(rightPane, 'right')}
						</GroupedMenuBodyRight>
					</GroupedMenuBody>
				</GroupedMenu>
				<div className="wds-label mt-3">{ gettext('Selected:') }</div>
				{ selected.length > 0
					? selected.map((item, index) => (
						<Tooltip
							key={index+'-'+item.id}
							text={item.group}
						>
							<Badge
								dismissible
								onClose={e => this.handleBadgeRemove(e, index)}
								show
							>
								{item.label}
							</Badge>
						</Tooltip>
					)) : (
						<p className="sma-piping-none-selected">{ gettext('No items selected') }</p>
					)
				}
				{ selected.some(item => item.isMulti) && (
					<div className="mt-2">
						<Select
							id="sma-js-pipes-delim-selector"
							label={gettext('Set how to display fields that have multiple results')}
							value=""
							stretched
							native
						>
							<Option value="">{gettext('Bulleted list (multi-line)')}</Option>
							<Option value="ol">{gettext('Numbered list (multi-line)')}</Option>
							<Option value="comma">{gettext('Comma (", ")')}</Option>
							<Option value="semicolon">{gettext('Semi-colon ("; ")')}</Option>
							<Option value="pipe">{gettext('Vertical line (" | ")')}</Option>
						</Select>
					</div>
				)}
			</React.Fragment>
		);
	}
}

Piper.propTypes = {
	data: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string.isRequired,
		id: PropTypes.number.isRequired,
		data: PropTypes.arrayOf(PropTypes.shape({
			id: PropTypes.number.isRequired,
			is_multi: PropTypes.bool.isRequired,
			label: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
		})),
		extra_data: PropTypes.shape({
			program_name: PropTypes.string,
			round_name: PropTypes.string,
		}),
	})).isRequired,
	updateQueue: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.admin/components/piper.jsx